module.exports = __webpack_public_path__ + "img/the-world-in-the-wave-function-cover.11b70c6c.jpg";